import React, { useState } from 'react';
import { C } from '../theme';
import { Card, CardTitle, RCard, QuoteBox } from '../components/Card';
import { calcRoot, ROOT_DATA } from '../utils/data';
import useUserStore from '../store/userStore';

const DECISIONS = [
  {label:'💍 زواج/خطوبة',val:'زواج أو خطوبة',roots:[2,6,9]},
  {label:'💼 بدء مشروع',val:'بدء عمل أو مشروع',roots:[1,3,8]},
  {label:'✈️ سفر/انتقال',val:'سفر أو انتقال',roots:[3,5,9]},
  {label:'📝 توقيع عقد',val:'توقيع عقد',roots:[1,4,8]},
  {label:'🤝 مصالحة',val:'مصالحة أو اتصال',roots:[2,6,3]},
  {label:'💰 استثمار',val:'استثمار أو شراء',roots:[4,8,1]},
];

const MONTH_NAMES = ['','يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];

export default function DatesScreen() {
  const [selected, setSelected] = useState(null);
  const { user } = useUserStore();
  const now = new Date();
  const year = now.getFullYear(), month = now.getMonth();
  const daysInMonth = new Date(year, month+1, 0).getDate();

  const bestDays = selected ? (() => {
    const days = [];
    for (let d = now.getDate(); d <= daysInMonth; d++) {
      const root = calcRoot(d, month+1, year);
      if (selected.roots.includes(root)) days.push({day:d, root, isUserRoot: root===user?.root_number});
    }
    return days;
  })() : [];

  return (
    <div>
      <QuoteBox text="الرقم الصحيح في التوقيت لا يصنع القرار، لكنه يفتح له الباب" src="جذر الفلك، الجزء الثالث" />
      <Card>
        <CardTitle>📆 أفضل تواريخ لقراراتك الكبرى</CardTitle>
        <p style={{fontSize:12,color:C.text2,marginBottom:14,lineHeight:1.7}}>اختر نوع القرار وسنعطيك أفضل التواريخ القادمة خلال الشهر الحالي.</p>
        <div style={{display:'flex',flexWrap:'wrap',gap:8,marginBottom:14}}>
          {DECISIONS.map(d=>(
            <button key={d.val} type="button" onClick={()=>setSelected(d===selected?null:d)}
              style={{padding:'8px 14px',borderRadius:20,border:`1px solid ${selected===d?C.gold:C.border}`,background:selected===d?'rgba(212,168,71,.1)':C.bg3,color:selected===d?C.gold:C.text2,cursor:'pointer',fontSize:12,fontFamily:'Cairo,sans-serif',transition:'all .2s'}}>
              {d.label}
            </button>
          ))}
        </div>

        {selected && (
          <div style={{animation:'fadeUp .3s ease'}}>
            {bestDays.length===0 ? (
              <RCard><div style={{fontSize:14}}>لا توجد تواريخ مثالية في بقية هذا الشهر. تحقق الشهر القادم.</div></RCard>
            ) : (
              <>
                <RCard type="pos" style={{marginBottom:10}}>
                  <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8}}>✦ أفضل أيام لـ: {selected.val}</div>
                  <div style={{fontSize:14,lineHeight:1.75,marginBottom:10}}>الأرقام المثلى: {selected.roots.map(r=>`${r}: ${ROOT_DATA[r]?.title?.split('—')[0]||''}`).join(' · ')}</div>
                  <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8}}>
                    {bestDays.slice(0,6).map(d=>(
                      <div key={d.day} style={{background:d.isUserRoot?'rgba(212,168,71,.15)':C.bg3,border:`1px solid ${d.isUserRoot?C.gold:C.border}`,borderRadius:10,padding:12,textAlign:'center',position:'relative'}}>
                        {d.isUserRoot&&<span style={{position:'absolute',top:4,left:4,fontSize:9,color:C.gold}}>✦ رقمك</span>}
                        <div style={{fontSize:22,fontFamily:'Amiri,serif',color:C.gold,fontWeight:700}}>{d.day}</div>
                        <div style={{fontSize:10,color:C.text2}}>{MONTH_NAMES[month+1]}</div>
                        <div style={{fontSize:11,color:C.text2,marginTop:3}}>رقم {d.root}</div>
                      </div>
                    ))}
                  </div>
                </RCard>
                <RCard style={{fontSize:12,color:C.text2}}>
                  <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8}}>💡 من الكتاب</div>
                  <div style={{fontSize:14,lineHeight:1.75}}>"اختر التاريخ الذي يحمل رقماً داعماً لطبيعة قرارك — الرقم لا يصنع القرار لكنه يفتح له الباب"</div>
                </RCard>
              </>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}
